/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AppContext, DataLinkContainer, debounce, ScrollableDataListRV } from 'plugin/liferay-widgets-react-web';
import { Col, Container, FormControl, Row } from 'external/react-bootstrap';

import { Map, MapLinkListItem } from 'plugin/map-portlet';

import BaseRemoteDataLayerController from '../map/BaseRemoteDataLayerController';

class BusinessObjectSelect extends React.Component {

  constructor(props) {
    super(props);
    this.layerDescription = {
      ...props.layer,
      controller: new BaseRemoteDataLayerController()
    };
    this.layerDescription.controller.onItemClick = (className, id, title, typeKey) => this.onChange({
      id,
      title,
      typeKey
    });

    this.DATA = { LIST: this.withCtx('BusinessObjectSelect') };
    this.state = {
      searchValue: ''
    };

    this.ListCHOC = DataLinkContainer.link(ScrollableDataListRV, [ 'list' ], this.props.store);
    this.searchList = debounce(this.searchList.bind(this), 300);
  }

  componentDidMount() {
    this.searchList('');
  }

  withCtx(s) {
    return this.props.formId + '.' + s;
  }

  more(query) {
    this.props.onMore(this.DATA.LIST, query);
  }

  updateSearch(e) {
    this.setState({ searchValue: e.target.value });
    this.searchList(e.target.value);
  }

  searchList(searchValue) {
    this.props.onSearch(this.DATA.LIST, {
      start: 0,
      end: AppContext.DEFAULT_LIST_SIZE,
      searchValue: searchValue || ''
    });
  }

  change(o) {
    this.props.onChange({ ...this.props.formData, ...o });
  }

  onChange(item) {
    const { id, title, typeKey = '' } = item;
    // don't remove 2nd id param!!!
    this.change({ [this.props.propName || 'id']: id, id, title, typeKey });
    this.setState({ title: title });
  }

  render() {
    const { searchValue } = this.state;
    const { noPadding, formData, propName, showMap = true } = this.props;
    let id = formData && propName ? formData[propName] : formData.id;
    const selectedItems = id && [ { className: this.props.className, id } ];

    return (
      <Container className={noPadding ? 'p-0 ' : 'py-3'}>
        <Row noGutters>
          <Col xs={12} sm={12} md={showMap ? 5 : 12}>
            <FormControl
              className="mb-3"
              type="text"
              value={searchValue}
              onChange={this.updateSearch.bind(this)}
              placeholder="Suchen"
            />

            <this.ListCHOC
              className="business-object-select-list"
              list={this.DATA.LIST}
              ListItem={this.props.CustomMapLinkListItem || MapLinkListItem}
              activeIds={{ id }}
              onClick={item => this.onChange(item)}
              onClickMore={this.more.bind(this)}
            />
          </Col>

          {
            showMap &&
            <Col xs={12} sm={12} md={7}>
              <h3 className="mb-3 pl-3">
                <span>{this.state && this.state.title ? this.state.title : 'Kein Eintrag ausgewählt'}</span>
              </h3>

              <div className="area-select pl-3">
                <div className="map" style={{ height: '365px' }}>
                  <Map
                    selectedItems={selectedItems}
                    defaultFallbackMapConfigType={'static'}
                    layerDescriptions={[ this.layerDescription ]}
                    activeUuids={{ [this.props.layer.uuid]: true }}
                    style={{ height: '365px' }}
                    zoom={12}
                  />
                </div>
              </div>
            </Col>
          }
        </Row>
      </Container>
    );
  }
}

BusinessObjectSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  formId: PropTypes.string.isRequired,
  formData: PropTypes.object,

  layer: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  propName: PropTypes.string,
  onMore: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired,
  CustomMapLinkListItem: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  noPadding: PropTypes.bool,
  showMap: PropTypes.bool,
};

export default BusinessObjectSelect;





// WEBPACK FOOTER //
// ./js/components/BusinessObjectSelect.jsx